/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface PaymentOptionsPrograms
 */
export interface PaymentOptionsPrograms {
  /**
   * Unique identifier for the program the user directs.
   * @type number
   * @memberof PaymentOptionsPrograms
   */
  programKey: number
  /**
   * The type of the program the user's student is enrolled in.
   * @type string
   * @memberof PaymentOptionsPrograms
   */
  programType: string
  /**
   * The name of the community the program is in.
   * @type string
   * @memberof PaymentOptionsPrograms
   */
  communityName: string
  /**
   * The date the first semester begins for the program.
   * @type Date
   * @memberof PaymentOptionsPrograms
   */
  semesterOneStartDate: Date
  /**
   * Unique identifier for the actor.
   * @type number
   * @memberof PaymentOptionsPrograms
   */
  actorKey?: number
}

export function PaymentOptionsProgramsFromJSON(
  json: any
): PaymentOptionsPrograms {
  return PaymentOptionsProgramsFromJSONTyped(json, false)
}

export function PaymentOptionsProgramsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaymentOptionsPrograms {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programKey: json['programKey'],
    programType: json['programType'],
    communityName: json['communityName'],
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
  }
}

export function PaymentOptionsProgramsToJSON(
  value?: PaymentOptionsPrograms | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programKey: value.programKey,
    programType: value.programType,
    communityName: value.communityName,
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    actorKey: value.actorKey,
  }
}
